module.exports = __webpack_public_path__ + "files/ce5c745533312987ea387886506ec394.png";